import React from 'react';
import { Tooltip } from 'primereact/tooltip';

const EnableTimeEntriesToggleSwitchV2 = (props) => {
  const { showTimeEntry, setShowTimeEntry, setTimeEntriesError, onToggleOff } = props || {};
  return (
    <>
      <div className="d-flex align-items-center mb-2">
        <span className="caption-bold mb-0 pe-4">Time Entries</span>
        <div>
          <label className="switch enable-time-entries-switch">
            <input
              type="checkbox"
              checked={showTimeEntry}
              onChange={(e) => {
                const isChecked = e.target.checked;
                setShowTimeEntry(isChecked);
                setTimeEntriesError({});
                // Clear filters when toggle is turned off
                if (!isChecked && onToggleOff) {
                  onToggleOff();
                }
              }}
            />
            <span className="slider round"></span>
          </label>
        </div>
        <Tooltip
          target=".enable-time-entries-switch"
          content="Select the date range to view the associated time entries"
          position="top"
          showDelay={300}
        />
      </div>
    </>
  );
};

export default EnableTimeEntriesToggleSwitchV2;
